import { Injectable } from '@angular/core';
import {ParentService} from "../../pages/A2-utils/ParentClass/ParentService";
import {Http} from "@angular/http";
import {constant} from "../../app.constants";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {CallTypeInterface} from "../interfaces/call-type.interface";

@Injectable()
export class CallTypeService extends ParentService{

  constructor(
    private _http: Http
  ) {
    super();
  }

  get (): Observable<CallTypeInterface[]>  {
    return this._http.get(constant.URL_CALL_TYPE, this.getHeader()).pipe(
      map( (response: any) => response.json() as CallTypeInterface[])
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/call-type.service.ts